import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { BUTTON_GROUP_ALIGNMENT as t } from "./button-group-constants.js";
import { createElementBlock as n, normalizeClass as r, openBlock as i, renderSlot as a } from "vue";
//#region components/button_group/button_group.vue
var o = {
	compatConfig: { MODE: 3 },
	name: "DtButtonGroup",
	props: { alignment: {
		type: String,
		default: "start",
		validator: (e) => Object.keys(t).includes(e)
	} },
	data() {
		return { BUTTON_GROUP_ALIGNMENT: t };
	}
};
function s(e, t, o, s, c, l) {
	return i(), n("div", {
		class: r(["d-btn-group", c.BUTTON_GROUP_ALIGNMENT[o.alignment]]),
		role: "group"
	}, [a(e.$slots, "default")], 2);
}
var c = /* @__PURE__ */ e(o, [["render", s]]);
//#endregion
export { c as default };

//# sourceMappingURL=button-group.js.map